<template>
  <div>
    <!-- <AddEmailToBranch :branchId="currentBranch" :key="componentKey"></AddEmailToBranch> -->
    <SetupBudget :branchId="currentBranchId" :data="details.data" />
    <MasterLayout>
      <div class="mobile__bg"></div>
      <div class="pt-5 pb-3 pl-4 pr-3 dashboard_first_row">
        <div class="row">
          <div class="col-md-8">
            <div class="py-5 pt-5 mb-3 row align-items-center white-bg">
              <div class="col-md-1 remove-right-padding col-center-flex">
                <div class="square-icon-wrapper small sky-bg">
                  <img src="@/assets/img/store-inv.png" width="35" />
                </div>
              </div>
              <div class="py-1 col-md-6">
                <h5 class="primary-color font-600">
                  {{ $t("text.branch.manageRetail") }}
                </h5>
                <p class="mt-3 light-grey-text">
                  {{ $t("text.branch.viewRetailOutlet") }}
                </p>
              </div>
              <div class="col-md-4 flexify"></div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="py-4 card_container">
              <div class="card__header___text">
                <div>
                  <h3 class="text-center our_branches__header">
                    {{ $t("text.branch.totalOutlets") }}
                  </h3>
                  <div class="mt-3 dealer__icon__wrapper">
                    <div class="text-center dealer__icon__div">
                      <div>
                        <img src="@/assets/img/store.png" width="35" />
                      </div>
                    </div>
                  </div>
                  <h3 class="mt-2 text-center our_branches__header">
                    {{ branchCount }}
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section class="table_align_div mt-3">
        <div class="">
          <div class="position-relative">
            <!-- :dataBound="dataBound" -->
            <ejs-grid
              v-show="!showLoader"
              ref="dataGrid"
              :created="refreshGrid"
              :allowPaging="true"
              :allowSorting="true"
              :pageSettings="pageSettings"
              :toolbar="toolbar"
              :searchSettings="search"
              :allowExcelExport="true"
              :allowPdfExport="true"
              :toolbarClick="toolbarClick"
              :locale="usedLang"
            >
              <e-columns>
                <e-column width="40" field="index" headerText="#"></e-column>
                <e-column
                  width="180"
                  field="dealerName"
                  :headerText="$t('text.branch.dealer')"
                ></e-column>
                <e-column
                  width="230"
                  field="name"
                  :headerText="$t('text.branch.name')"
                ></e-column>
                <e-column
                  width="180"
                  field="city"
                  :headerText="$t('text.branch.city')"
                ></e-column>
                <e-column
                  width="200"
                  field="state"
                  :headerText="$t('text.branch.state')"
                ></e-column>
                <e-column
                  width="200"
                  :template="buttonsTemplate"
                  :headerText="$t('text.actionButtons.title')"
                ></e-column>
                <!-- <e-column width="60" :template="optionsTemplate"></e-column> -->
              </e-columns>
            </ejs-grid>
            <TableLoader :showLoader="showLoader" />
            <DropDown :details="details" />
          </div>
        </div>
      </section>
    </MasterLayout>
    <SetMaximumCashAmount :branchId="currentBranchId" />
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Dealer/MasterLayout.vue";
import backgroundUrl from "@/assets/img/BecomeDealer.png";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import configObject from "@/config";
import JQuery from "jquery";
import TableLoader from "@/components/tableLoader/index";
import Temp from "@/components/TableTemplates/branchDealer.vue";
import AddEmailToBranch from "@/components/modals/AddEmailToBranch/index";
import SetMaximumCashAmount from "@/components/modals/maximumCashAmount";
import SetupBudget from "@/components/modals/branch/setupBudget";
import DropDown from "@/components/Templates/Dropdown/branchesDropdown.vue";
import templatePrimary from "@/components/Templates/branchesListTemplate.vue";

let $ = JQuery;
import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
  Resize,
} from "@syncfusion/ej2-vue-grids";

export default {
  title: "Retail Outlets:: Epump Portal",
  name: "OurBranches",
  components: {
    MasterLayout,
    TableLoader,
    AddEmailToBranch,
    SetMaximumCashAmount,
    DropDown,
    SetupBudget,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport, Resize],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      branches: [],
      dealerId: null,
      backgroundUrl,
      componentKey: 0,
      cardBackgroundUrl,
      showLoader: true,
      branchCount: 0,
      currentBranch: null,
      currentBranchId: null,
      dealer: null,
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
      details: {
        data: { status: "" },
        queryStrings: { id: "" },
        info: [{ name: "Set budget", emitName: "setUpBudget" }],
        delete: {
          hasDelete: false,
          deleteName: "deleteInvoice",
          name: "Delete",
          query: "id",
        },
      },
      optionsTemplate: function () {
        return {
          template: templatePrimary,
        };
      },
      buttonsTemplate: function () {
        return {
          template: Temp,
        };
      },
    };
  },
  created() {
    this.$eventHub.$on("dealer", (dealer) => {
      this.dealer = dealer;
    });
    if (this.$route.query.dealerId) {
      this.getBranches();
    }
    // if (this.$route.query.dealerId) {
    //   this.getBranches();
    // }
    this.$eventHub.$on("showBranhesConfig", (data) => {
      this.details.data = data;
      this.details.queryStrings.id = data.id;
      const viewData =
        document.getElementsByClassName("e-grid")[0].ej2_instances[0]
          .currentViewData;
      const option = document.getElementById("myDropdown");
      option.classList.add("show");
      let index;
      const findindex = viewData.findIndex(
        (branch) => branch.index === data.index
      );
      console.log(findindex);
      if (data.index > 10) {
        index = findindex;
      }
      if (data.index <= 10) {
        index = data.index;
      }
      if (viewData.length < 10) {
        option.style.top = `${(
          80 * index +
          (80 - index * 2) -
          406
        ).toString()}px`;
      } else {
        option.style.top = `${(80 * index + (80 - index * 2)).toString()}px`;
      }
    });

    this.$eventHub.$on(this.details.info[0].emitName, (id) => {
      this.setupBudget(id);
    });
    this.$eventHub.$on("_setAmount", (branchId) => {
      this.currentBranchId = branchId;
      this.$modal.show("setMaximumCashAmount");
    });
    this.$eventHub.$on("link", (url, branchId) => {
      if (this.$route.name == url) {
        return;
      }
      this.$router.push({ name: url, query: { branchId } });
    });
    this.$eventHub.$on("gotoBranch", (url, id) => {
      if (this.$route.name == url) {
        return;
      }
      this.$router.push({ name: url, query: { id } });
    });
    this.$eventHub.$on("addEmail", (branchId) => {
      this.showAddEmailToBranchModal(branchId);
    });
  },
  beforeDestroy() {
    this.$store.commit("setBranchTable", null);
    this.$eventHub.$off("link");
    this.$eventHub.$off("gotoBranch");
  },

  watch: {
    dealer(dealer) {
      if (dealer !== null) {
        this.getBranches();
      }
    },
    $route(to, from) {
      if (from.query.dealerId && !to.query.dealerId) {
        this.getBranches();
      }
    },
  },
  mounted() {
    this.dealerId = this.$route.query.dealerId;

    $(".e-input").keyup((e) => {
      searchFun(e);
    });
    const searchFun = (event) => {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
      setTimeout(() => {
        this.$store.commit("setBranchTable", grid.currentViewData.length);
      }, 500);
    };
  },
  methods: {
    setupBudget(id) {
      this.currentBranchId = id;
      this.$modal.show("setupBudgetModal");
    },
    forceRerender() {
      this.componentKey += 1;
    },
    showAddEmailToBranchModal(branchId) {
      this.currentBranch = branchId;
      this.$eventHub.$emit("addEmailBranchId", branchId);
      this.$modal.show("emailToBranch");
    },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },
    changeRoute($newRoute, id) {
      let branch = this.branches.filter((branch) => branch.id == id)[0];
      localStorage.setItem("branchDetails", JSON.stringify(branch));
      this.$router.push({ name: $newRoute, query: { id: id } });
    },
    changeRoute2($newRoute, id) {
      let branch = this.branches.filter((branch) => branch.id == id)[0];
      localStorage.setItem("branchDetails", JSON.stringify(branch));
      this.$router.push({
        path: "/Retail-Outlet/Dashboard",
        query: { id: id },
      });
    },
    getBranches() {
      this.showLoader = true;
      let grid = this.$refs.dataGrid;
      let url = "";
      if (!this.$route.query.dealerId) {
        url = `${configObject.apiBaseUrl}/Company/DealerBranches/${
          this.$route.query.dealerId
            ? this.$route.query.dealerId
            : this.dealer.id
        }`;
      } else {
        url = `${configObject.apiBaseUrl}/Company/DealerBranches/${this.$route.query.dealerId}`;
      }
      this.axios
        .get(url, configObject.authConfig())
        .then((response) => {
          let index = 0;
          response.data.sort((a, b) => {
            if (a.dealerName === b.dealerName) {
              return a.name > b.name ? 1 : -1;
            }
            return a.dealerName > b.dealerName ? 1 : -1;
          });
          response.data.forEach((dealer) => {
            index++;
            dealer.index = index;
            dealer.detailsTip = this.$t("text.branch.details");
            dealer.mailRecipientTip = this.$t("text.branch.mailRecipient");
            dealer.manageTargetsTip = this.$t("text.branch.manageTargets");
            dealer.mapUserToBranchTip = this.$t("text.branch.mapUserToBranch");
          });
          this.showLoader = false;
          this.branchCount = response.data.length;
          this.branches = response.data;
          if (response.data.length == 1) {
            this.$store.commit("setBranchTable", 1);
          }
          localStorage.setItem("branches", JSON.stringify(response.data));
          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: response.data,
          });
          this.refreshGrid();
        })
        .catch((error) => {});
    },
  },
};
</script>
